import { useRef, useState } from 'react';
import styled from 'styled-components';
import {
  AdminInput,
  ChatInput,
  CommentInput,
  CurrencyInput,
  DefaultInput,
  FormInput,
  SearchInput,
  ShoutInput
} from './components';

const Wrapper = styled.div`
  margin: ${(props) => props.marg || 0};
  width: ${(props) => props.wid || '100%'};
  padding: ${(props) => props.pad || '0'};
  cursor: text;
`;

const Input = (props) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  function getComponent() {
    switch (true) {
      case props.form:
        return <FormInput {...props} inputRef={props.inputRef || inputRef} />;
      case props.admin:
        return <AdminInput {...props} inputRef={props.inputRef || inputRef} />;
      case props.search:
        return <SearchInput {...props} inputRef={props.inputRef || inputRef} />;
      case props.chat:
        return <ChatInput {...props} inputRef={props.inputRef || inputRef} />;
      case props.currency:
        return (
          <CurrencyInput
            {...props}
            isFocused={isFocused}
            setIsFocused={setIsFocused}
            inputRef={props.inputRef || inputRef}
          />
        );
      case props.comment:
        return <CommentInput {...props} inputRef={props.inputRef || inputRef} />;
      case props.shoutout:
        return (
          <ShoutInput
            {...props}
            isFocused={isFocused}
            setIsFocused={setIsFocused}
            inputRef={props.inputRef || inputRef}
          />
        );
      default:
        return (
          <DefaultInput
            {...props}
            isFocused={isFocused}
            setIsFocused={setIsFocused}
            inputRef={props.inputRef || inputRef}
          />
        );
    }
  }

  return (
    <Wrapper
      {...props}
      onClick={(e) => {
        // clicks inside the emoji button/picker must not steal focus back to the input
        if (e.target.closest?.('.emoji-button, .EmojiPickerReact')) return;

        // TODO: SHOULD BE FIXED URGENTLY
        e.preventDefault();

        inputRef?.current?.focus();
      }}
    >
      {getComponent()}
    </Wrapper>
  );
};

export default Input;
